<template>
  <RevDrawer
    :close-button-label="i18n(translations.close)"
    :name="MODAL_NAMES.REASSURANCE"
    :title="i18n(translations.title)"
  >
    <template #body>
      <h2 class="heading-3 mb-16">
        {{ i18n(translations.titleSatisfaction) }}
      </h2>
      <SatisfactionModalContent :cooling-off-days />

      <RevDivider class="my-16" />

      <h2 class="heading-3 mb-16">
        {{ i18n(translations.titleWarranty) }}
      </h2>
      <WarrantyModalContent :warranty-location>
        <WarrantyExclusion />
      </WarrantyModalContent>
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import SatisfactionModalContent from '@backmarket/nuxt-layer-product-modals/SatisfactionModalContent.vue'
import WarrantyExclusion from '@backmarket/nuxt-layer-product-modals/WarrantyExclusion.vue'
import WarrantyModalContent from '@backmarket/nuxt-layer-product-modals/WarrantyModalContent.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevDivider } from '@ds/components/Divider'
import { RevDrawer } from '@ds/components/Drawer'

import { CMS } from '~/scopes/cms/routes-names'
import { LEGAL_PAGE_NAME } from '~/scopes/legal/constants'
import { MODAL_NAMES } from '~/scopes/product-core/constants'

import translations from './ReassuranceModal.translations'

const i18n = useI18n()

const { features } = useMarketplace()
const { coolingOffDays } = features

const warrantyLocation = {
  name: CMS.LEGAL_PAGE,
  params: {
    pageName: LEGAL_PAGE_NAME.WARRANTY,
  },
}
</script>
